import { DISCOUNT_RELEVANCE_DAYS_COUNT } from 'config/constants';

export const calculateDiscountRelevance = (
  dateFinish: string | null | undefined,
  dateStart: string | undefined,
) => {
  let discountEndDate;
  let relevanceStartingDate;

  if (!dateFinish && !dateStart) return false;

  if (dateFinish) {
    discountEndDate = new Date(dateFinish);
    relevanceStartingDate = discountEndDate.setDate(
      discountEndDate.getDate() - DISCOUNT_RELEVANCE_DAYS_COUNT,
    );
  } else {
    if (!dateStart) return undefined;
    const discountStartDay = new Date(dateStart);
    const addOneYear = (date: Date) => {
      date.setFullYear(date.getFullYear() + 1);
      return date;
    };

    relevanceStartingDate = addOneYear(discountStartDay);
  }

  return relevanceStartingDate <= Date.now();
};
